window.BARFEGO_QUIZ_PRODUCTS = [
  {
    "handle": "barf-mix-alles-vom-huhn",
    "title": "Alles vom Huhn",
    "type": "",
    "kind": "menu",
    "species": "dog",
    "proteins": [
      "poultry"
    ],
    "needs": [],
    "pack": 1000
  },
  {
    "handle": "barf-mix-alles-vom-lamm",
    "title": "Alles vom Lamm",
    "type": "",
    "kind": "menu",
    "species": "dog",
    "proteins": [
      "lamb"
    ],
    "needs": [],
    "pack": 1000
  },
  {
    "handle": "barf-mix-alles-vom-pferd",
    "title": "Alles vom Pferd",
    "type": "",
    "kind": "menu",
    "species": "dog",
    "proteins": [
      "horse"
    ],
    "needs": [],
    "pack": 1000
  },
  {
    "handle": "barf-mix-alles-vom-rind",
    "title": "Alles vom Rind",
    "type": "",
    "kind": "menu",
    "species": "dog",
    "proteins": [
      "beef"
    ],
    "needs": [
      "joints"
    ],
    "pack": 1000
  },
  {
    "handle": "ergaenzungsfuttermittel-aniforte-seealgenmehl-250g",
    "title": "Aniforte Seealgenmehl, 250g",
    "type": "Ergänzungsfuttermittel",
    "kind": "supplement",
    "species": "dog",
    "proteins": [],
    "needs": [
      "digestion",
      "skin"
    ],
    "pack": 250
  },
  {
    "handle": "ergaenzungsfuttermittel-aniforte-afrikanische-teufelskralle",
    "title": "AniForte® Afrikanische Teufelskralle",
    "type": "Ergänzungsfuttermittel",
    "kind": "supplement",
    "species": "both",
    "proteins": [],
    "needs": [
      "joints"
    ],
    "pack": 250
  },
  {
    "handle": "ergaenzungsfuttermittel-aniforte-bierhefe-pulver",
    "title": "AniForte® Bierhefe Pulver",
    "type": "Ergänzungsfuttermittel",
    "kind": "supplement",
    "species": "cat",
    "proteins": [],
    "needs": [
      "skin"
    ],
    "pack": 250
  },
  {
    "handle": "aniforte-bio-kokosoel",
    "title": "Aniforte® Bio Kokosöl",
    "type": "",
    "kind": "supplement",
    "species": "dog",
    "proteins": [],
    "needs": [
      "skin"
    ],
    "pack": 0
  },
  {
    "handle": "ergaenzungsfuttermittel-aniforte-bio-spirulina-250-g",
    "title": "AniForte® Bio Spirulina 250 g",
    "type": "Ergänzungsfuttermittel",
    "kind": "supplement",
    "species": "both",
    "proteins": [],
    "needs": [],
    "pack": 250
  },
  {
    "handle": "ergaenzungsfuttermittel-aniforte-blasen-formel-pulver-100-g",
    "title": "AniForte® Blasen-Formel Pulver 100 g",
    "type": "Ergänzungsfuttermittel",
    "kind": "supplement",
    "species": "dog",
    "proteins": [],
    "needs": [
      "urinary"
    ],
    "pack": 100
  },
  {
    "handle": "ergaenzungsfuttermittel-aniforte-eierschalen-pulver",
    "title": "AniForte® Eierschalen Pulver",
    "type": "Ergänzungsfuttermittel",
    "kind": "supplement",
    "species": "both",
    "proteins": [],
    "needs": [
      "joints"
    ],
    "pack": 100
  },
  {
    "handle": "ergaenzungsfuttermittel-aniforte-flohsamenschalen-1-kg",
    "title": "AniForte® Flohsamenschalen 1 kg",
    "type": "Ergänzungsfuttermittel",
    "kind": "supplement",
    "species": "both",
    "proteins": [],
    "needs": [
      "digestion",
      "weight"
    ],
    "pack": 1000
  },
  {
    "handle": "ergaenzungsfuttermittel-aniforte-gelenkvetal-3-250-g",
    "title": "AniForte® GelenkVETAL 3 250 g",
    "type": "Ergänzungsfuttermittel",
    "kind": "supplement",
    "species": "dog",
    "proteins": [],
    "needs": [
      "joints"
    ],
    "pack": 250
  },
  {
    "handle": "ergaenzungsfuttermittel-aniforte-gemahlene-knochen-vom-pferd",
    "title": "AniForte® Gemahlene Knochen vom Pferd",
    "type": "Ergänzungsfuttermittel",
    "kind": "supplement",
    "species": "both",
    "proteins": [
      "horse"
    ],
    "needs": [
      "joints"
    ],
    "pack": 0
  },
  {
    "handle": "ergaenzungsfuttermittel-aniforte-gemahlene-knochen-vom-rind",
    "title": "AniForte® Gemahlene Knochen vom Rind",
    "type": "Ergänzungsfuttermittel",
    "kind": "supplement",
    "species": "both",
    "proteins": [
      "beef"
    ],
    "needs": [
      "joints"
    ],
    "pack": 0
  },
  {
    "handle": "ergaenzungsfuttermittel-aniforte-gruenlippmuschel-pulver",
    "title": "AniForte® Grünlippmuschel Pulver",
    "type": "Ergänzungsfuttermittel",
    "kind": "supplement",
    "species": "both",
    "proteins": [
      "fish"
    ],
    "needs": [
      "joints"
    ],
    "pack": 500
  },
  {
    "handle": "ergaenzungsfuttermittel-aniforte-hagebutten-pulver",
    "title": "AniForte® Hagebutten Pulver",
    "type": "Ergänzungsfuttermittel",
    "kind": "supplement",
    "species": "both",
    "proteins": [],
    "needs": [],
    "pack": 250
  },
  {
    "handle": "ergaenzungsfuttermittel-aniforte-heilmoor",
    "title": "AniForte® Heilmoor",
    "type": "Ergänzungsfuttermittel",
    "kind": "supplement",
    "species": "dog",
    "proteins": [],
    "needs": [
      "digestion"
    ],
    "pack": 750
  },
  {
    "handle": "ergaenzungsfuttermittel-aniforte-indische-flohsamen-1-kg",
    "title": "AniForte® Indische Flohsamen 1 kg",
    "type": "Ergänzungsfuttermittel",
    "kind": "supplement",
    "species": "dog",
    "proteins": [
      "horse"
    ],
    "needs": [
      "digestion",
      "weight"
    ],
    "pack": 1000
  },
  {
    "handle": "ergaenzungsfuttermittel-aniforte-junior-active-pulver-250-g",
    "title": "AniForte® Junior Active Pulver 250 g",
    "type": "Ergänzungsfuttermittel",
    "kind": "supplement",
    "species": "dog",
    "proteins": [],
    "needs": [
      "puppy",
      "active"
    ],
    "pack": 250
  },
  {
    "handle": "ergaenzungsfuttermittel-aniforte-nierenvetal-pulver-hund-100-g",
    "title": "AniForte® NierenVetal Pulver Hund 100 g",
    "type": "Ergänzungsfuttermittel",
    "kind": "supplement",
    "species": "dog",
    "proteins": [],
    "needs": [],
    "pack": 100
  },
  {
    "handle": "ergaenzungsfuttermittel-aniforte-plus-fell-haut",
    "title": "AniForte® plus Fell & Haut",
    "type": "Ergänzungsfuttermittel",
    "kind": "supplement",
    "species": "dog",
    "proteins": [],
    "needs": [
      "skin"
    ],
    "pack": 0
  },
  {
    "handle": "ergaenzungsfuttermittel-aniforte-premium-colostrum-100-g",
    "title": "AniForte® Premium Colostrum 100 g",
    "type": "Ergänzungsfuttermittel",
    "kind": "supplement",
    "species": "both",
    "proteins": [],
    "needs": [],
    "pack": 100
  },
  {
    "handle": "ergaenzungsfuttermittel-aniforte-senior-active-250-g",
    "title": "AniForte® Senior Active 250 g",
    "type": "Ergänzungsfuttermittel",
    "kind": "supplement",
    "species": "dog",
    "proteins": [],
    "needs": [
      "senior",
      "active"
    ],
    "pack": 250
  },
  {
    "handle": "ergaenzungsfuttermittel-aniforte-taurin-pulver",
    "title": "AniForte® Taurin Pulver",
    "type": "Ergänzungsfuttermittel",
    "kind": "supplement",
    "species": "dog",
    "proteins": [],
    "needs": [],
    "pack": 0
  },
  {
    "handle": "ergaenzungsfuttermittel-aniforte-ulmenrinde-pulver",
    "title": "AniForte® Ulmenrinde Pulver",
    "type": "Ergänzungsfuttermittel",
    "kind": "supplement",
    "species": "both",
    "proteins": [
      "beef"
    ],
    "needs": [
      "digestion"
    ],
    "pack": 100
  },
  {
    "handle": "balf-trockenbarf-menue-gefluegel",
    "title": "Balf Trockenbarf Menü Geflügel",
    "type": "Trockenfutter",
    "kind": "menu",
    "species": "dog",
    "proteins": [
      "poultry"
    ],
    "needs": [],
    "pack": 0
  },
  {
    "handle": "balf-trockenbarf-menue-lamm",
    "title": "Balf Trockenbarf Menü Lamm",
    "type": "Trockenfutter",
    "kind": "menu",
    "species": "dog",
    "proteins": [
      "lamb"
    ],
    "needs": [],
    "pack": 0
  },
  {
    "handle": "balf-trockenbarf-menue-pferd",
    "title": "Balf Trockenbarf Menü Pferd",
    "type": "Trockenfutter",
    "kind": "menu",
    "species": "dog",
    "proteins": [
      "horse"
    ],
    "needs": [],
    "pack": 0
  },
  {
    "handle": "balf-trockenbarf-menue-rind",
    "title": "Balf Trockenbarf Menü Rind",
    "type": "Trockenfutter",
    "kind": "menu",
    "species": "dog",
    "proteins": [
      "beef"
    ],
    "needs": [],
    "pack": 0
  },
  {
    "handle": "getrockneter-fruechtemix",
    "title": "BARFeGO® Früchtemix",
    "type": "Obst & Gemüse",
    "kind": "component",
    "species": "dog",
    "proteins": [],
    "needs": [],
    "pack": 0
  },
  {
    "handle": "getrockneter-gemuesetopf",
    "title": "BARFeGO® Gemüsetopf",
    "type": "Obst & Gemüse",
    "kind": "component",
    "species": "dog",
    "proteins": [],
    "needs": [],
    "pack": 0
  },
  {
    "handle": "getrockneter-kraeutergarten",
    "title": "BARFeGO® Kräutergarten",
    "type": "Obst & Gemüse",
    "kind": "component",
    "species": "dog",
    "proteins": [],
    "needs": [],
    "pack": 0
  },
  {
    "handle": "getrockneter-querbeet-gemuesemix",
    "title": "BARFeGO® Querbeet",
    "type": "Obst & Gemüse",
    "kind": "component",
    "species": "dog",
    "proteins": [],
    "needs": [],
    "pack": 0
  },
  {
    "handle": "barfgold-komplett-menue-fuer-katzen-gefluegel-und-makrele",
    "title": "Barfgold Komplett-Menü für Katzen, Geflügel und Makrele",
    "type": "BARF Mixe",
    "kind": "menu",
    "species": "cat",
    "proteins": [
      "poultry",
      "fish"
    ],
    "needs": [],
    "pack": 0
  },
  {
    "handle": "barfgold-komplett-menue-fuer-katzen-huhn",
    "title": "Barfgold Komplett-Menü für Katzen, Huhn",
    "type": "BARF Mixe",
    "kind": "menu",
    "species": "cat",
    "proteins": [
      "poultry"
    ],
    "needs": [],
    "pack": 0
  },
  {
    "handle": "innereien-blaettermagen-vom-rind-1-kg",
    "title": "Blättermagen vom Rind, 1 kg",
    "type": "Innereien",
    "kind": "component",
    "species": "both",
    "proteins": [
      "beef"
    ],
    "needs": [
      "digestion"
    ],
    "pack": 1000
  },
  {
    "handle": "barf-bunter-gartenmix-stueckig-500-gramm",
    "title": "bunter Gartenmix, stückig, 500 Gramm",
    "type": "Obst & Gemüse",
    "kind": "component",
    "species": "dog",
    "proteins": [],
    "needs": [],
    "pack": 500
  },
  {
    "handle": "kauartikel-dorschhaut-donuts-getrocknet",
    "title": "Dorschhaut-Donuts, getrocknet",
    "type": "Kauartikel",
    "kind": "snack",
    "species": "dog",
    "proteins": [
      "fish"
    ],
    "needs": [
      "skin"
    ],
    "pack": 500
  },
  {
    "handle": "ergaenzungsfuttermittel-dorschleberoel-fuer-hunde",
    "title": "Dorschleberöl für Hunde",
    "type": "Futteröle",
    "kind": "supplement",
    "species": "dog",
    "proteins": [
      "fish"
    ],
    "needs": [
      "skin"
    ],
    "pack": 250
  },
  {
    "handle": "entenfleisch-leckerli-trainingssnack",
    "title": "Entenfleisch Leckerli, Trainingssnack",
    "type": "Trainingssnacks",
    "kind": "snack",
    "species": "dog",
    "proteins": [
      "poultry"
    ],
    "needs": [],
    "pack": 1000
  },
  {
    "handle": "barf-entenfleisch-durchwachsen-1-kg",
    "title": "Entenfleisch, durchwachsen, 1 kg",
    "type": "Muskelfleisch",
    "kind": "component",
    "species": "both",
    "proteins": [
      "poultry"
    ],
    "needs": [],
    "pack": 1000
  },
  {
    "handle": "barf-entenfleisch-mager-1-kg",
    "title": "Entenfleisch, mager, 1 kg",
    "type": "Muskelfleisch",
    "kind": "component",
    "species": "both",
    "proteins": [
      "poultry"
    ],
    "needs": [
      "weight"
    ],
    "pack": 1000
  },
  {
    "handle": "fleischige-entenhaelse-1-kg",
    "title": "Entenhälse, 1 kg",
    "type": "Fleischige Knochen",
    "kind": "component",
    "species": "both",
    "proteins": [
      "poultry"
    ],
    "needs": [],
    "pack": 1000
  },
  {
    "handle": "innereien-entenherzen-500-gramm",
    "title": "Entenherzen, 500 Gramm",
    "type": "Innereien",
    "kind": "component",
    "species": "both",
    "proteins": [
      "poultry"
    ],
    "needs": [],
    "pack": 500
  },
  {
    "handle": "kauartikel-flunder-getrocknet",
    "title": "Flunder, getrocknet",
    "type": "Kauartikel",
    "kind": "snack",
    "species": "dog",
    "proteins": [
      "fish"
    ],
    "needs": [
      "skin"
    ],
    "pack": 0
  },
  {
    "handle": "barf-gelber-gemuesemix-fein-geraspelt-500-gramm",
    "title": "gelber Gemüsemix, fein geraspelt, 500 Gramm",
    "type": "Obst & Gemüse",
    "kind": "component",
    "species": "dog",
    "proteins": [],
    "needs": [],
    "pack": 500
  },
  {
    "handle": "kauartikel-getrocknete-sprotten",
    "title": "Getrocknete Sprotten",
    "type": "Kauartikel",
    "kind": "snack",
    "species": "dog",
    "proteins": [
      "fish"
    ],
    "needs": [
      "skin"
    ],
    "pack": 200
  },
  {
    "handle": "barf-gruener-gemuesemix-fein-geraspelt-500-gramm",
    "title": "grüner Gemüsemix, fein geraspelt, 500 Gramm",
    "type": "Obst & Gemüse",
    "kind": "component",
    "species": "dog",
    "proteins": [],
    "needs": [],
    "pack": 500
  },
  {
    "handle": "kauartikel-haehnchenhaelse-getrocknet",
    "title": "Hähnchenhälse, getrocknet",
    "type": "Kauartikel",
    "kind": "snack",
    "species": "dog",
    "proteins": [
      "poultry"
    ],
    "needs": [],
    "pack": 500
  },
  {
    "handle": "ergaenzungsfuttermittel-hanfoel-fuer-hunde-nativ-kaltgepresst",
    "title": "Hanföl für Hunde, nativ kaltgepresst",
    "type": "Futteröle",
    "kind": "supplement",
    "species": "dog",
    "proteins": [],
    "needs": [
      "skin"
    ],
    "pack": 250
  },
  {
    "handle": "hirschfleisch-leckerli-trainingssnack",
    "title": "Hirschfleisch Leckerli, Trainingssnack",
    "type": "Trainingssnacks",
    "kind": "snack",
    "species": "dog",
    "proteins": [
      "game"
    ],
    "needs": [],
    "pack": 200
  },
  {
    "handle": "barf-hirschfleisch-500-gramm",
    "title": "Hirschfleisch, 500 Gramm",
    "type": "Muskelfleisch",
    "kind": "component",
    "species": "both",
    "proteins": [
      "game"
    ],
    "needs": [],
    "pack": 500
  },
  {
    "handle": "kauartikel-hirschrippen-1-kg",
    "title": "Hirschrippen, 1 kg",
    "type": "Kauartikel",
    "kind": "snack",
    "species": "dog",
    "proteins": [
      "game"
    ],
    "needs": [
      "joints"
    ],
    "pack": 1000
  },
  {
    "handle": "kauartikel-hirschrippen-bogen-xxl",
    "title": "Hirschrippen-Bogen XXL, ganz",
    "type": "Kauartikel",
    "kind": "snack",
    "species": "dog",
    "proteins": [
      "game"
    ],
    "needs": [],
    "pack": 0
  },
  {
    "handle": "huhn-barf-komplett-menue-gewolft-1-kg",
    "title": "Huhn Komplett-Menü, gewolft, 1 kg",
    "type": "BARF Mixe",
    "kind": "menu",
    "species": "dog",
    "proteins": [
      "poultry"
    ],
    "needs": [],
    "pack": 1000
  },
  {
    "handle": "huehnerfett-500-gramm",
    "title": "Hühnerfett, 500 Gramm",
    "type": "Fett",
    "kind": "component",
    "species": "both",
    "proteins": [
      "poultry"
    ],
    "needs": [
      "active"
    ],
    "pack": 500
  },
  {
    "handle": "huehnerfleisch-leckerli-trainingssnack",
    "title": "Hühnerfleisch Leckerli, Trainingssnack",
    "type": "Trainingssnacks",
    "kind": "snack",
    "species": "dog",
    "proteins": [
      "poultry"
    ],
    "needs": [],
    "pack": 200
  },
  {
    "handle": "kauartikel-haehnchenfuesse-getrocknet",
    "title": "Hühnerfüße, getrocknet",
    "type": "Kauartikel",
    "kind": "snack",
    "species": "dog",
    "proteins": [
      "poultry"
    ],
    "needs": [],
    "pack": 1000
  },
  {
    "handle": "fleischige-huehnerhaelse-1-kg",
    "title": "Hühnerhälse, 1 kg",
    "type": "Fleischige Knochen",
    "kind": "component",
    "species": "both",
    "proteins": [
      "beef",
      "poultry"
    ],
    "needs": [
      "joints"
    ],
    "pack": 1000
  },
  {
    "handle": "innereien-huehnerherzen-500-gramm",
    "title": "Hühnerherzen, 500 Gramm",
    "type": "Innereien",
    "kind": "component",
    "species": "both",
    "proteins": [
      "poultry"
    ],
    "needs": [],
    "pack": 500
  },
  {
    "handle": "innereien-huehnerleber-500-gramm",
    "title": "Hühnerleber, 500 Gramm",
    "type": "Innereien",
    "kind": "component",
    "species": "both",
    "proteins": [
      "poultry"
    ],
    "needs": [],
    "pack": 500
  },
  {
    "handle": "innereien-huehnermaegen-500-gramm",
    "title": "Hühnermägen, 500 Gramm",
    "type": "Innereien",
    "kind": "component",
    "species": "both",
    "proteins": [
      "poultry"
    ],
    "needs": [],
    "pack": 500
  },
  {
    "handle": "barf-huehnermuskelfleisch-mager",
    "title": "Hühnermuskelfleisch, mager",
    "type": "",
    "kind": "component",
    "species": "dog",
    "proteins": [
      "poultry"
    ],
    "needs": [
      "weight"
    ],
    "pack": 1000
  },
  {
    "handle": "huehnerruecken-in-stuecken-500-gramm",
    "title": "Hühnerrücken, in Stücken, 500 Gramm",
    "type": "Fleischige Knochen",
    "kind": "component",
    "species": "both",
    "proteins": [
      "beef",
      "poultry"
    ],
    "needs": [
      "joints"
    ],
    "pack": 500
  },
  {
    "handle": "hundeeis-apfel-banane-hagebutte",
    "title": "Hundeeis - Apfel Banane Hagebutte",
    "type": "Kauartikel",
    "kind": "snack",
    "species": "dog",
    "proteins": [],
    "needs": [],
    "pack": 0
  },
  {
    "handle": "hundeeis-erdnuss-banane",
    "title": "Hundeeis - Erdnuss Banane",
    "type": "Kauartikel",
    "kind": "snack",
    "species": "dog",
    "proteins": [],
    "needs": [],
    "pack": 0
  },
  {
    "handle": "hundeeis-vegan-banane-kokos-mango",
    "title": "Hundeeis - vegan - Banane Kokos Mango",
    "type": "Kauartikel",
    "kind": "snack",
    "species": "dog",
    "proteins": [],
    "needs": [],
    "pack": 0
  },
  {
    "handle": "kauartikel-iberico-schweineohren",
    "title": "Iberico Schweineohren",
    "type": "Kauartikel",
    "kind": "snack",
    "species": "dog",
    "proteins": [
      "pork"
    ],
    "needs": [],
    "pack": 0
  },
  {
    "handle": "ergaenzungsfuttermittel-joint-powder-plus",
    "title": "Joint Powder Plus",
    "type": "Ergänzungsfuttermittel",
    "kind": "supplement",
    "species": "dog",
    "proteins": [],
    "needs": [
      "joints"
    ],
    "pack": 0
  },
  {
    "handle": "kauartikel-kalb-unterbein-getrocknet-1-stueck",
    "title": "Kalb Unterbein, getrocknet 1 Stück",
    "type": "Kauartikel",
    "kind": "snack",
    "species": "dog",
    "proteins": [
      "beef"
    ],
    "needs": [
      "skin",
      "joints"
    ],
    "pack": 0
  },
  {
    "handle": "fleischige-kalbsbrustbeinknochen-in-stuecken-1-kg",
    "title": "Kalbsbrustbeinknochen, in Stücken, 1 kg",
    "type": "Fleischige Knochen",
    "kind": "component",
    "species": "both",
    "proteins": [
      "beef"
    ],
    "needs": [
      "joints"
    ],
    "pack": 1000
  },
  {
    "handle": "fleischige-kalbsbrustbeinknochen-kleine-stuecke-1-kg",
    "title": "Kalbsbrustbeinknochen, kleine Stücke, 1 kg",
    "type": "Fleischige Knochen",
    "kind": "component",
    "species": "both",
    "proteins": [
      "beef"
    ],
    "needs": [
      "joints"
    ],
    "pack": 1000
  },
  {
    "handle": "innereien-kalbsmilz-500-gramm",
    "title": "Kalbsmilz, 500 Gramm",
    "type": "Innereien",
    "kind": "component",
    "species": "both",
    "proteins": [
      "beef"
    ],
    "needs": [],
    "pack": 500
  },
  {
    "handle": "kauartikel-kamel-kopfhaut-extra-hart",
    "title": "Kamel Kopfhaut, extra hart",
    "type": "Kauartikel",
    "kind": "snack",
    "species": "dog",
    "proteins": [
      "camel"
    ],
    "needs": [
      "skin"
    ],
    "pack": 400
  },
  {
    "handle": "kangurufleisch",
    "title": "Kängurufleisch, 1 kg",
    "type": "Muskelfleisch",
    "kind": "component",
    "species": "both",
    "proteins": [
      "kangaroo"
    ],
    "needs": [],
    "pack": 1000
  },
  {
    "handle": "kaenguru-innereienmix-500-gramm",
    "title": "Känguruinnereienmix, 500 Gramm",
    "type": "Innereien",
    "kind": "component",
    "species": "both",
    "proteins": [
      "kangaroo"
    ],
    "needs": [],
    "pack": 500
  },
  {
    "handle": "kauartikel-kaninchen-ohr-mit-fell-getrocknet",
    "title": "Kaninchen-Ohr mit Fell, getrocknet",
    "type": "Kauartikel",
    "kind": "snack",
    "species": "dog",
    "proteins": [
      "rabbit"
    ],
    "needs": [
      "skin"
    ],
    "pack": 1000
  },
  {
    "handle": "kaninchenfleisch-leckerli-trainingssnack",
    "title": "Kaninchenfleisch Leckerli, Trainingssnack",
    "type": "Trainingssnacks",
    "kind": "snack",
    "species": "dog",
    "proteins": [
      "rabbit"
    ],
    "needs": [],
    "pack": 200
  },
  {
    "handle": "barf-kaninchenfleisch-stueckig-1-kg",
    "title": "Kaninchenfleisch, stückig, 1 kg",
    "type": "Muskelfleisch",
    "kind": "component",
    "species": "both",
    "proteins": [
      "rabbit"
    ],
    "needs": [],
    "pack": 1000
  },
  {
    "handle": "kauartikel-katzenhai-getrocknet-1-stk",
    "title": "Katzenhai, getrocknet, 1 Stk",
    "type": "Kauartikel",
    "kind": "snack",
    "species": "dog",
    "proteins": [
      "fish"
    ],
    "needs": [],
    "pack": 0
  },
  {
    "handle": "kauartikel-kalbsziemer-1-stk",
    "title": "Kauartikel Kalbsziemer, 1 Stk.",
    "type": "Kauartikel",
    "kind": "snack",
    "species": "dog",
    "proteins": [
      "beef"
    ],
    "needs": [],
    "pack": 0
  },
  {
    "handle": "fleischiger-knorpel-vom-rind-1-kg",
    "title": "Knorpel vom Rind, 1 kg",
    "type": "Fleischige Knochen",
    "kind": "component",
    "species": "both",
    "proteins": [
      "beef"
    ],
    "needs": [],
    "pack": 1000
  },
  {
    "handle": "lachs-barf-komplett-menue-gewolft-1-kg",
    "title": "Lachs Komplett-Menü, gewolft, 1 kg",
    "type": "BARF Mixe",
    "kind": "menu",
    "species": "dog",
    "proteins": [
      "fish"
    ],
    "needs": [],
    "pack": 1000
  },
  {
    "handle": "ergaenzungsfuttermittel-lachsoel-fuer-hunde-fischoel",
    "title": "Lachsöl für Hunde, Fischöl",
    "type": "Futteröle",
    "kind": "supplement",
    "species": "dog",
    "proteins": [
      "fish"
    ],
    "needs": [
      "skin"
    ],
    "pack": 250
  },
  {
    "handle": "barf-lachswuerfel-500-gramm",
    "title": "Lachswürfel, 500 Gramm",
    "type": "Fisch",
    "kind": "component",
    "species": "both",
    "proteins": [
      "fish"
    ],
    "needs": [],
    "pack": 500
  },
  {
    "handle": "lamm-barf-komplett-menue-gewolft-1-kg",
    "title": "Lamm Komplett-Menü, gewolft, 1 kg",
    "type": "BARF Mixe",
    "kind": "menu",
    "species": "dog",
    "proteins": [
      "lamb"
    ],
    "needs": [],
    "pack": 1000
  },
  {
    "handle": "lammfett-500-gramm",
    "title": "Lammfett, 500 Gramm",
    "type": "Fett",
    "kind": "component",
    "species": "both",
    "proteins": [
      "lamb"
    ],
    "needs": [
      "active"
    ],
    "pack": 500
  },
  {
    "handle": "lammfleisch-leckerli-trainingssnack",
    "title": "Lammfleisch Leckerli, Trainingssnack",
    "type": "Trainingssnacks",
    "kind": "snack",
    "species": "dog",
    "proteins": [
      "lamb"
    ],
    "needs": [],
    "pack": 200
  },
  {
    "handle": "innereien-lammherzen-1-kg",
    "title": "Lammherzen, 1 kg",
    "type": "Innereien",
    "kind": "component",
    "species": "both",
    "proteins": [
      "lamb"
    ],
    "needs": [],
    "pack": 1000
  },
  {
    "handle": "lamminnereienmix-1-kg",
    "title": "Lamminnereienmix, 1 kg",
    "type": "Innereien",
    "kind": "component",
    "species": "both",
    "proteins": [
      "lamb"
    ],
    "needs": [],
    "pack": 1000
  },
  {
    "handle": "lammknochenmus-500-gramm",
    "title": "Lammknochenmus, 500 Gramm",
    "type": "Fleischige Knochen",
    "kind": "component",
    "species": "both",
    "proteins": [
      "lamb"
    ],
    "needs": [
      "joints"
    ],
    "pack": 500
  },
  {
    "handle": "innereien-lammleber-500-gramm",
    "title": "Lammleber, 500 Gramm",
    "type": "Innereien",
    "kind": "component",
    "species": "both",
    "proteins": [
      "lamb"
    ],
    "needs": [],
    "pack": 500
  },
  {
    "handle": "barf-lammmuskelfleisch-durchwachsen",
    "title": "Lammmuskelfleisch, durchwachsen",
    "type": "",
    "kind": "component",
    "species": "dog",
    "proteins": [
      "lamb"
    ],
    "needs": [],
    "pack": 1000
  },
  {
    "handle": "barf-lammmuskelfleisch-durchwachsen-gewolft-500-gramm",
    "title": "Lammmuskelfleisch, durchwachsen, gewolft, 500 Gramm",
    "type": "Muskelfleisch",
    "kind": "component",
    "species": "both",
    "proteins": [
      "lamb"
    ],
    "needs": [],
    "pack": 500
  },
  {
    "handle": "barf-lammmuskelfleisch-mager-1-kg",
    "title": "Lammmuskelfleisch, mager, 1 kg",
    "type": "Muskelfleisch",
    "kind": "component",
    "species": "both",
    "proteins": [
      "lamb"
    ],
    "needs": [
      "weight"
    ],
    "pack": 1000
  },
  {
    "handle": "kauartikel-lammpansen",
    "title": "Lammpansen",
    "type": "Kauartikel",
    "kind": "snack",
    "species": "dog",
    "proteins": [
      "lamb"
    ],
    "needs": [
      "digestion"
    ],
    "pack": 500
  },
  {
    "handle": "innereien-lammpansen-gruen-1-kg",
    "title": "Lammpansen, grün, 1 kg",
    "type": "Innereien",
    "kind": "component",
    "species": "both",
    "proteins": [
      "lamb"
    ],
    "needs": [
      "digestion"
    ],
    "pack": 1000
  },
  {
    "handle": "fleischige-lammrippenknochen-1-kg",
    "title": "Lammrippenknochen, 1 kg",
    "type": "Fleischige Knochen",
    "kind": "component",
    "species": "both",
    "proteins": [
      "lamb"
    ],
    "needs": [
      "joints"
    ],
    "pack": 1000
  },
  {
    "handle": "ergaenzungsfuttermittel-leinoel-fuer-hunde-kaltgepresst",
    "title": "Leinöl für Hunde, kaltgepresst",
    "type": "Futteröle",
    "kind": "supplement",
    "species": "dog",
    "proteins": [],
    "needs": [
      "skin"
    ],
    "pack": 1000
  },
  {
    "handle": "makana-glucosamin-hcl-pulver-fuer-tiere-1000-g-beutel",
    "title": "Makana Glucosamin HCL Pulver für Tiere, 1000 g Beutel",
    "type": "Ergänzungsfuttermittel",
    "kind": "supplement",
    "species": "dog",
    "proteins": [],
    "needs": [],
    "pack": 1000
  },
  {
    "handle": "makana-msm-glucosamin-chondroitin-hyaluronsaeure-500-gramm",
    "title": "makana MSM Glucosamin Chondroitin + Hyaluronsäure, 500 Gramm",
    "type": "Ergänzungsfuttermittel",
    "kind": "supplement",
    "species": "dog",
    "proteins": [],
    "needs": [
      "joints"
    ],
    "pack": 500
  },
  {
    "handle": "barf-makrelen-1-kg",
    "title": "Makrelen, 1 kg",
    "type": "Fisch",
    "kind": "component",
    "species": "both",
    "proteins": [
      "fish"
    ],
    "needs": [
      "skin"
    ],
    "pack": 1000
  },
  {
    "handle": "manako-msm-methylsulfonylmethan-kristallines-pulver-999-rein-1-kg-beutel",
    "title": "manako MSM - Methylsulfonylmethan -  kristallines Pulver, 99,9% rein, 1 kg Beutel",
    "type": "Ergänzungsfuttermittel",
    "kind": "supplement",
    "species": "dog",
    "proteins": [],
    "needs": [
      "joints"
    ],
    "pack": 1000
  },
  {
    "handle": "ergaenzungsfuttermittel-mariendisteloel-fuer-hunde-nativ-kaltgepresst",
    "title": "Mariendistelöl für Hunde, nativ kaltgepresst",
    "type": "Futteröle",
    "kind": "supplement",
    "species": "dog",
    "proteins": [],
    "needs": [],
    "pack": 250
  },
  {
    "handle": "trainingssnack-mini-lungen-wuerfel-vom-lamm",
    "title": "Mini Lungen Würfel vom Lamm - Trainingssnack",
    "type": "Trainingssnacks",
    "kind": "snack",
    "species": "dog",
    "proteins": [
      "lamb"
    ],
    "needs": [],
    "pack": 500
  },
  {
    "handle": "mini-lungen-wuerfel-vom-pferd-trainingssnack",
    "title": "Mini Lungen Würfel vom Pferd - Trainingssnack",
    "type": "Trainingssnacks",
    "kind": "snack",
    "species": "dog",
    "proteins": [
      "horse"
    ],
    "needs": [],
    "pack": 500
  },
  {
    "handle": "trainingssnack-mini-lungen-wuerfel-vom-rind",
    "title": "Mini Lungen Würfel vom Rind",
    "type": "Trainingssnacks",
    "kind": "snack",
    "species": "dog",
    "proteins": [
      "beef"
    ],
    "needs": [],
    "pack": 500
  },
  {
    "handle": "kauartikel-ochsenziemer-1-meter",
    "title": "Ochsenziemer, 1 Meter",
    "type": "Kauartikel",
    "kind": "snack",
    "species": "dog",
    "proteins": [
      "beef"
    ],
    "needs": [],
    "pack": 0
  },
  {
    "handle": "kauartikel-ochsenziemer-12-cm-5-stk",
    "title": "Ochsenziemer, 12 cm - 5 Stk",
    "type": "Kauartikel",
    "kind": "snack",
    "species": "dog",
    "proteins": [
      "beef"
    ],
    "needs": [],
    "pack": 0
  },
  {
    "handle": "petman-eintagskueken-1-kg",
    "title": "Petman Eintagsküken 1 kg",
    "type": "Futtertiere",
    "kind": "component",
    "species": "cat",
    "proteins": [
      "poultry"
    ],
    "needs": [],
    "pack": 1000
  },
  {
    "handle": "petman-eintagskueken-4-stueck",
    "title": "Petman Eintagsküken 4 Stück",
    "type": "Futtertiere",
    "kind": "component",
    "species": "cat",
    "proteins": [
      "poultry"
    ],
    "needs": [],
    "pack": 0
  },
  {
    "handle": "petman-mice-on-ice-baby",
    "title": "Petman MICE on ice - baby",
    "type": "Futtertiere",
    "kind": "component",
    "species": "cat",
    "proteins": [],
    "needs": [],
    "pack": 0
  },
  {
    "handle": "petman-mice-on-ice-big-5-stueck",
    "title": "Petman MICE on ice - big 5 Stück",
    "type": "Futtertiere",
    "kind": "component",
    "species": "cat",
    "proteins": [],
    "needs": [],
    "pack": 0
  },
  {
    "handle": "petman-rabbit-on-ice-small-2-stueck",
    "title": "Petman RABBIT on ice - small, 2 Stück",
    "type": "Futtertiere",
    "kind": "component",
    "species": "cat",
    "proteins": [
      "rabbit"
    ],
    "needs": [],
    "pack": 0
  },
  {
    "handle": "kauartikel-pferd-doerrfleisch-getrocknet-200-gramm",
    "title": "Pferd Dörrfleisch, getrocknet 200 Gramm",
    "type": "Kauartikel",
    "kind": "snack",
    "species": "dog",
    "proteins": [
      "horse"
    ],
    "needs": [],
    "pack": 200
  },
  {
    "handle": "pferd-barf-komplett-menue-gewolft-1-kg",
    "title": "Pferd Komplett-Menü, gewolft, 1 kg",
    "type": "BARF Mixe",
    "kind": "menu",
    "species": "dog",
    "proteins": [
      "horse"
    ],
    "needs": [],
    "pack": 1000
  },
  {
    "handle": "kauartikel-pferd-kopfhaut-mit-fell-getrocknet",
    "title": "Pferd Kopfhaut mit Fell, getrocknet",
    "type": "Kauartikel",
    "kind": "snack",
    "species": "dog",
    "proteins": [
      "horse"
    ],
    "needs": [
      "digestion",
      "skin"
    ],
    "pack": 1000
  },
  {
    "handle": "kauartikel-pferd-kopfhaut-ohne-fell-getrocknet",
    "title": "Pferd Kopfhaut ohne Fell, getrocknet",
    "type": "Kauartikel",
    "kind": "snack",
    "species": "dog",
    "proteins": [
      "horse"
    ],
    "needs": [
      "skin"
    ],
    "pack": 500
  },
  {
    "handle": "kauartikel-pferde-ohren-mit-fell",
    "title": "Pferde-Ohren mit Fell",
    "type": "Kauartikel",
    "kind": "snack",
    "species": "dog",
    "proteins": [
      "horse"
    ],
    "needs": [
      "skin"
    ],
    "pack": 0
  },
  {
    "handle": "kauartikel-pferde-ohren-ohne-fell",
    "title": "Pferde-Ohren ohne Fell",
    "type": "Kauartikel",
    "kind": "snack",
    "species": "dog",
    "proteins": [
      "horse"
    ],
    "needs": [
      "skin"
    ],
    "pack": 0
  },
  {
    "handle": "pferdefett-500-gramm",
    "title": "Pferdefett, 500 Gramm",
    "type": "Fett",
    "kind": "component",
    "species": "both",
    "proteins": [
      "horse"
    ],
    "needs": [],
    "pack": 500
  },
  {
    "handle": "pferdefleisch-leckerli-trainingssnack",
    "title": "Pferdefleisch Leckerli, Trainingssnack",
    "type": "Trainingssnacks",
    "kind": "snack",
    "species": "dog",
    "proteins": [
      "horse"
    ],
    "needs": [],
    "pack": 500
  },
  {
    "handle": "pferdehaut-ohne-fell-gerollt",
    "title": "Pferdehaut ohne Fell, gerollt",
    "type": "Kauartikel",
    "kind": "snack",
    "species": "dog",
    "proteins": [
      "horse"
    ],
    "needs": [
      "skin"
    ],
    "pack": 1000
  },
  {
    "handle": "kauartikel-pferdehaut-platten-1-kg",
    "title": "Pferdehaut Platten, 1 kg",
    "type": "Kauartikel",
    "kind": "snack",
    "species": "dog",
    "proteins": [
      "horse"
    ],
    "needs": [
      "skin"
    ],
    "pack": 1000
  },
  {
    "handle": "innereien-pferdeherzen-1-kg",
    "title": "Pferdeherzen, 1 kg",
    "type": "Innereien",
    "kind": "component",
    "species": "both",
    "proteins": [
      "horse"
    ],
    "needs": [],
    "pack": 1000
  },
  {
    "handle": "pferdeinnereienmix-gewolft-1-kg",
    "title": "Pferdeinnereienmix, gewolft, 1 kg",
    "type": "Innereien",
    "kind": "component",
    "species": "both",
    "proteins": [
      "horse"
    ],
    "needs": [],
    "pack": 1000
  },
  {
    "handle": "pferdeknochenmus-500-gramm",
    "title": "Pferdeknochenmus, 500 Gramm",
    "type": "Fleischige Knochen",
    "kind": "component",
    "species": "both",
    "proteins": [
      "horse"
    ],
    "needs": [
      "joints"
    ],
    "pack": 500
  },
  {
    "handle": "kauartikel-pferdelunge-1-kg",
    "title": "Pferdelunge 1 kg",
    "type": "Kauartikel",
    "kind": "snack",
    "species": "dog",
    "proteins": [
      "horse"
    ],
    "needs": [],
    "pack": 1000
  },
  {
    "handle": "barf-pferdemuskelfleisch",
    "title": "Pferdemuskelfleisch",
    "type": "",
    "kind": "component",
    "species": "dog",
    "proteins": [
      "horse"
    ],
    "needs": [],
    "pack": 1000
  },
  {
    "handle": "kauartikel-pferdeschwanz-1-kg",
    "title": "Pferdeschwanz, 1 kg",
    "type": "Kauartikel",
    "kind": "snack",
    "species": "dog",
    "proteins": [
      "horse"
    ],
    "needs": [
      "joints"
    ],
    "pack": 1000
  },
  {
    "handle": "kauartikel-pferdesehnen-1-kg",
    "title": "Pferdesehnen, 1 kg",
    "type": "Kauartikel",
    "kind": "snack",
    "species": "dog",
    "proteins": [
      "horse"
    ],
    "needs": [
      "joints"
    ],
    "pack": 1000
  },
  {
    "handle": "kauartikel-pferdeziemer-1-stk",
    "title": "Pferdeziemer, 1 Stk",
    "type": "Kauartikel",
    "kind": "snack",
    "species": "dog",
    "proteins": [
      "horse"
    ],
    "needs": [],
    "pack": 0
  },
  {
    "handle": "probierpaket-barf-komplettmenue",
    "title": "Probierpaket BARF-Komplettmenü",
    "type": "BARF Mixe",
    "kind": "menu",
    "species": "dog",
    "proteins": [],
    "needs": [],
    "pack": 0
  },
  {
    "handle": "putenfleisch-leckerli-trainingssnack",
    "title": "Putenfleisch Leckerli, Trainingssnack",
    "type": "Trainingssnacks",
    "kind": "snack",
    "species": "dog",
    "proteins": [
      "poultry"
    ],
    "needs": [],
    "pack": 500
  },
  {
    "handle": "fleischige-putenhaelse-1-kg",
    "title": "Putenhälse, 1 kg",
    "type": "Fleischige Knochen",
    "kind": "component",
    "species": "both",
    "proteins": [
      "poultry"
    ],
    "needs": [],
    "pack": 1000
  },
  {
    "handle": "kauartikel-putenhaelse-getrocknet-1-kg",
    "title": "Putenhälse, getrocknet, 1 kg",
    "type": "Kauartikel",
    "kind": "snack",
    "species": "dog",
    "proteins": [
      "poultry"
    ],
    "needs": [],
    "pack": 1000
  },
  {
    "handle": "barf-putenmuskelfleisch-1-kg",
    "title": "Putenmuskelfleisch, 1 kg",
    "type": "Muskelfleisch",
    "kind": "component",
    "species": "both",
    "proteins": [
      "poultry"
    ],
    "needs": [],
    "pack": 1000
  },
  {
    "handle": "kauartikel-rehbein-getrocknet-1-stueck",
    "title": "Rehbein, getrocknet 1 Stück",
    "type": "Kauartikel",
    "kind": "snack",
    "species": "dog",
    "proteins": [
      "game"
    ],
    "needs": [
      "skin"
    ],
    "pack": 0
  },
  {
    "handle": "european-pet-pharmacy-rehydration-regeneration-fuer-hunde",
    "title": "Rehydration – Regeneration für Hunde",
    "type": "Ergänzungsfuttermittel",
    "kind": "supplement",
    "species": "dog",
    "proteins": [
      "game"
    ],
    "needs": [],
    "pack": 0
  },
  {
    "handle": "ergaenzungsfuttermittel-reiskeimoel-fuer-hunde",
    "title": "Reiskeimöl für Hunde",
    "type": "Futteröle",
    "kind": "supplement",
    "species": "dog",
    "proteins": [],
    "needs": [
      "skin",
      "active"
    ],
    "pack": 250
  },
  {
    "handle": "kauartikel-rind-doerrfleisch-getrocknet-200-gramm",
    "title": "Rind Dörrfleisch, getrocknet 200 Gramm",
    "type": "Kauartikel",
    "kind": "snack",
    "species": "dog",
    "proteins": [
      "beef"
    ],
    "needs": [],
    "pack": 200
  },
  {
    "handle": "rind-barf-komplett-menue-gewolft-1-kg",
    "title": "Rind Komplett-Menü, gewolft, 1 kg",
    "type": "BARF Mixe",
    "kind": "menu",
    "species": "dog",
    "proteins": [
      "beef"
    ],
    "needs": [],
    "pack": 1000
  },
  {
    "handle": "kauartikel-rinder-ohren-honiggelb-1-stk",
    "title": "Rinder Ohren honiggelb 1 Stk.",
    "type": "Kauartikel",
    "kind": "snack",
    "species": "dog",
    "proteins": [
      "beef"
    ],
    "needs": [],
    "pack": 0
  },
  {
    "handle": "kauartikel-rinder-ohren-mit-fell",
    "title": "Rinder Ohren mit Fell",
    "type": "Kauartikel",
    "kind": "snack",
    "species": "dog",
    "proteins": [
      "beef"
    ],
    "needs": [
      "skin"
    ],
    "pack": 0
  },
  {
    "handle": "kauartikel-rinder-ohren-mit-muschel",
    "title": "Rinder Ohren mit Muschel",
    "type": "Kauartikel",
    "kind": "snack",
    "species": "dog",
    "proteins": [
      "beef"
    ],
    "needs": [
      "weight"
    ],
    "pack": 0
  },
  {
    "handle": "kauartikel-rinder-pansen",
    "title": "Rinder-Pansen",
    "type": "Kauartikel",
    "kind": "snack",
    "species": "dog",
    "proteins": [
      "beef"
    ],
    "needs": [
      "digestion"
    ],
    "pack": 1000
  },
  {
    "handle": "rinderfett-500-gramm",
    "title": "Rinderfett, 500 Gramm",
    "type": "Fett",
    "kind": "component",
    "species": "both",
    "proteins": [
      "beef"
    ],
    "needs": [
      "active"
    ],
    "pack": 500
  },
  {
    "handle": "kauartikel-rinderhaut-platten-xxl",
    "title": "Rinderhaut Platten XXL",
    "type": "Kauartikel",
    "kind": "snack",
    "species": "dog",
    "proteins": [
      "beef"
    ],
    "needs": [
      "skin"
    ],
    "pack": 0
  },
  {
    "handle": "kauartikel-rinderhaut-platten-1-kg",
    "title": "Rinderhaut Platten, 1 kg",
    "type": "Kauartikel",
    "kind": "snack",
    "species": "dog",
    "proteins": [
      "beef"
    ],
    "needs": [
      "skin"
    ],
    "pack": 1000
  },
  {
    "handle": "innereien-rinderherz-1-kg",
    "title": "Rinderherz, 1 kg",
    "type": "Innereien",
    "kind": "component",
    "species": "both",
    "proteins": [
      "beef"
    ],
    "needs": [],
    "pack": 1000
  },
  {
    "handle": "innereien-rinderinnereienmix-1-kg",
    "title": "Rinderinnereienmix, 1 kg",
    "type": "Innereien",
    "kind": "component",
    "species": "both",
    "proteins": [
      "beef"
    ],
    "needs": [],
    "pack": 1000
  },
  {
    "handle": "rinderknochen-gross-1-kg",
    "title": "Rinderknochen, groß, 1 kg",
    "type": "Fleischige Knochen",
    "kind": "component",
    "species": "both",
    "proteins": [
      "beef"
    ],
    "needs": [
      "joints"
    ],
    "pack": 1000
  },
  {
    "handle": "rinderknochenmus-500-gramm",
    "title": "Rinderknochenmus, 500 Gramm",
    "type": "Fleischige Knochen",
    "kind": "component",
    "species": "both",
    "proteins": [
      "beef"
    ],
    "needs": [
      "joints"
    ],
    "pack": 500
  },
  {
    "handle": "innereien-rinderleber-500-gramm",
    "title": "Rinderleber, 500 Gramm",
    "type": "Innereien",
    "kind": "component",
    "species": "both",
    "proteins": [
      "beef"
    ],
    "needs": [],
    "pack": 500
  },
  {
    "handle": "innereien-rinderlunge-500-gramm",
    "title": "Rinderlunge, 500 Gramm",
    "type": "Innereien",
    "kind": "component",
    "species": "both",
    "proteins": [
      "beef"
    ],
    "needs": [],
    "pack": 500
  },
  {
    "handle": "barf-rindermuskelfleisch-durchwachsen",
    "title": "Rindermuskelfleisch, durchwachsen",
    "type": "",
    "kind": "component",
    "species": "dog",
    "proteins": [
      "beef",
      "poultry"
    ],
    "needs": [],
    "pack": 1000
  },
  {
    "handle": "barf-rindermuskelfleisch-durchwachsen-gewolft-500-gramm",
    "title": "Rindermuskelfleisch, durchwachsen, gewolft, 500 Gramm",
    "type": "Muskelfleisch",
    "kind": "component",
    "species": "both",
    "proteins": [
      "beef"
    ],
    "needs": [],
    "pack": 500
  },
  {
    "handle": "barf-rindermuskelfleisch-mager",
    "title": "Rindermuskelfleisch, mager",
    "type": "",
    "kind": "component",
    "species": "dog",
    "proteins": [
      "beef"
    ],
    "needs": [
      "weight"
    ],
    "pack": 1000
  },
  {
    "handle": "innereien-rinderniere-500-gramm",
    "title": "Rinderniere, 500 Gramm",
    "type": "Innereien",
    "kind": "component",
    "species": "both",
    "proteins": [
      "beef"
    ],
    "needs": [
      "weight"
    ],
    "pack": 500
  },
  {
    "handle": "rinderohren-mit-fell-mit-muschel",
    "title": "Rinderohren mit Fell, mit Muschel",
    "type": "Fleischige Knochen",
    "kind": "component",
    "species": "both",
    "proteins": [
      "beef"
    ],
    "needs": [
      "skin"
    ],
    "pack": 0
  },
  {
    "handle": "innereien-rinderpansen-gruen-1-kg",
    "title": "Rinderpansen, grün, 1 kg",
    "type": "Innereien",
    "kind": "component",
    "species": "both",
    "proteins": [
      "beef"
    ],
    "needs": [
      "digestion"
    ],
    "pack": 1000
  },
  {
    "handle": "rinderzunge-mager-1-kg",
    "title": "Rinderzunge, mager, 1 kg",
    "type": "Innereien",
    "kind": "component",
    "species": "both",
    "proteins": [
      "beef"
    ],
    "needs": [
      "weight"
    ],
    "pack": 1000
  },
  {
    "handle": "rindfleisch-leckerli-trainingssnack",
    "title": "Rindfleisch Leckerli, Trainingssnack",
    "type": "Kauartikel",
    "kind": "snack",
    "species": "dog",
    "proteins": [
      "beef"
    ],
    "needs": [],
    "pack": 1000
  },
  {
    "handle": "kauartikel-rotauge-getrocknet",
    "title": "Rotauge, getrocknet",
    "type": "Kauartikel",
    "kind": "snack",
    "species": "dog",
    "proteins": [
      "fish"
    ],
    "needs": [],
    "pack": 0
  },
  {
    "handle": "barf-roter-fruechtemix-fein-geraspelt-500-gramm",
    "title": "roter Früchtemix, fein geraspelt, 500 Gramm",
    "type": "Obst & Gemüse",
    "kind": "component",
    "species": "dog",
    "proteins": [],
    "needs": [],
    "pack": 500
  },
  {
    "handle": "kauartikel-schellfisch-getrocknet",
    "title": "Schellfisch, getrocknet",
    "type": "Kauartikel",
    "kind": "snack",
    "species": "dog",
    "proteins": [
      "fish"
    ],
    "needs": [],
    "pack": 0
  },
  {
    "handle": "hundewurst-fahrtenwurst-trainingssnack",
    "title": "Schnittfeste Hundewurst & Fährtenwurst",
    "type": "Trainingssnacks",
    "kind": "snack",
    "species": "dog",
    "proteins": [],
    "needs": [],
    "pack": 1000
  },
  {
    "handle": "ergaenzungsfuttermittel-schwarzkuemmeloel-fuer-hunde-kaltgepresst",
    "title": "Schwarzkümmelöl für Hunde, kaltgepresst",
    "type": "Futteröle",
    "kind": "supplement",
    "species": "dog",
    "proteins": [],
    "needs": [],
    "pack": 250
  },
  {
    "handle": "european-pet-pharmacy-sport-fuer-aktive-hunde",
    "title": "Sport – für aktive Hunde",
    "type": "Ergänzungsfuttermittel",
    "kind": "supplement",
    "species": "dog",
    "proteins": [],
    "needs": [],
    "pack": 0
  },
  {
    "handle": "barf-sprotten-500-gramm",
    "title": "Sprotten, 500 Gramm",
    "type": "Fisch",
    "kind": "component",
    "species": "both",
    "proteins": [
      "fish"
    ],
    "needs": [
      "skin"
    ],
    "pack": 500
  },
  {
    "handle": "barf-sprotten-gewolft-500-gramm",
    "title": "Sprotten, gewolft, 500 Gramm",
    "type": "Fisch",
    "kind": "component",
    "species": "both",
    "proteins": [
      "fish"
    ],
    "needs": [
      "skin"
    ],
    "pack": 500
  },
  {
    "handle": "wolfsblut-adult-dark-forest-wild-mit-suesskartoffeln-nassfutter",
    "title": "Wolfsblut Adult Dark Forest - Wild mit Süßkartoffeln Nassfutter",
    "type": "Nassfutter",
    "kind": "menu",
    "species": "dog",
    "proteins": [
      "game"
    ],
    "needs": [],
    "pack": 200
  },
  {
    "handle": "wolfsblut-adult-wild-duck-ente-mit-kartoffeln-nassfutter",
    "title": "Wolfsblut Adult Wild Duck - Ente mit Kartoffeln Nassfutter",
    "type": "Nassfutter",
    "kind": "menu",
    "species": "dog",
    "proteins": [
      "poultry",
      "game"
    ],
    "needs": [],
    "pack": 200
  },
  {
    "handle": "wolfsblut-trockenfutter-atlantic-tuna-thunfisch-meeressalat-125-kg",
    "title": "Wolfsblut Trockenfutter Atlantic Tuna - Thunfisch & Meeressalat 12,5 kg",
    "type": "Trockenfutter",
    "kind": "menu",
    "species": "dog",
    "proteins": [
      "fish",
      "game"
    ],
    "needs": [],
    "pack": 12500
  },
  {
    "handle": "ziegeninnereienmix-gewolft-500-gramm",
    "title": "Ziegeninnereienmix, gewolft, 500 Gramm",
    "type": "Innereien",
    "kind": "component",
    "species": "both",
    "proteins": [
      "goat"
    ],
    "needs": [],
    "pack": 500
  },
  {
    "handle": "barf-ziegenmuskelfleisch-durchwachsen-1-kg",
    "title": "Ziegenmuskelfleisch, durchwachsen, 1 kg",
    "type": "Muskelfleisch",
    "kind": "component",
    "species": "both",
    "proteins": [
      "goat"
    ],
    "needs": [],
    "pack": 1000
  },
  {
    "handle": "fleischige-ziegennackenknochen-1-kg",
    "title": "Ziegennackenknochen, 1 kg",
    "type": "Fleischige Knochen",
    "kind": "component",
    "species": "both",
    "proteins": [
      "goat"
    ],
    "needs": [
      "joints"
    ],
    "pack": 1000
  },
  {
    "handle": "innereien-ziegenpansen-gruen-1-kg",
    "title": "Ziegenpansen, grün, 1 kg",
    "type": "Innereien",
    "kind": "component",
    "species": "both",
    "proteins": [
      "goat"
    ],
    "needs": [
      "digestion"
    ],
    "pack": 1000
  }
];
